import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Card, Col, Row } from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay';
import Loader from 'react-loaders';
import GetFileListBySubCategoryService from '../../../../../../../../../../Service/DashboardServices/AssetGalleryServices/GetFileListBySubCategoryService';
import ImportedFilesAssets from './ImportedFilesAssets';

function GoogleDriveAssetsDetails(props) {
  const [allFileListOfAssets, setAllFileListOfAssets] = useState([]);
  const [loadScreen, setLoadScreen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  const fetchImportedFiles = () => {
    setLoadScreen(true);
    const data = {
      integerId: props.storeOverview.integerID,
      assetCategory: 3,
      subCategoryId: '',
      assetIdentifier: '',
    };

    GetFileListBySubCategoryService(props.token, data).then((response) => {
      setLoadScreen(false);
      if (response) {
        setAllFileListOfAssets(response.fileList || []);
        setTotalCount(response.counts || (response.fileList || []).length);
      } else {
        setAllFileListOfAssets([]);
        setTotalCount(0);
      }
    });
  };

  useEffect(() => {
    fetchImportedFiles();
  }, [props.storeOverview.integerID, props.refreshKey]);

  return (
    <div>
      <Card className="p-3 mb-2 child-card">
        <Row className="align-items-center">
          <Col md={8}>
            <h5 className="mb-1"><b>Imported Files</b></h5>
            <p className="mb-0 text-muted" style={{ fontSize: 13 }}>
              Assets imported from Google Drive (Category ID: 3)
            </p>
          </Col>
          <Col md={4} className="text-md-right">
            <span className="assets-category-count">{totalCount}</span>
            <span className="ml-2"><b>Total Files</b></span>
          </Col>
        </Row>
      </Card>

      <LoadingOverlay
        active={loadScreen}
        styles={{
          overlay: (base) => ({
            ...base,
            background: '#f1f4f6',
            opacity: 1,
          }),
          content: (base) => ({
            ...base,
            color: '#000',
          }),
        }}
        spinner={<Loader active type="ball-pulse" />}
        text="Loading imported files..."
      >
        <Card className="p-3 child-card">
          <ImportedFilesAssets
            allFileListOfAssets={allFileListOfAssets}
            setAllFileListOfAssets={setAllFileListOfAssets}
            assetCategory={3}
            onRefresh={fetchImportedFiles}
          />
        </Card>
      </LoadingOverlay>
    </div>
  );
}

const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
  storeOverview: state.accountOverview.store.storeOverview,
});

export default connect(mapStateToProps)(GoogleDriveAssetsDetails);
